import {Component} from "react";
import {Button, Layout, message, Modal, Select, Space, Table, InputNumber, Spin, FormInstance, Form} from "antd";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavFooter from "../../components/NavFooter";

import '../css/main.less'
import React from "react";
import AxiosUtil from "../../utils/AxiosUtil";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import TaskList from "./components/TaskList";
import DataUtil from "../../utils/DataUtil";

const {Content} = Layout;

interface IProps {
}

export default class TaskAssign extends Component<IProps> {

    autoRef = React.createRef<FormInstance>();
    taskListRef: TaskList | undefined;
    onTaskListRef = (ref: any) => {
        this.taskListRef = ref;
    }

    state = {
        // autoList: [],
        autoSum: 0,
        autoTotal: 0,
        manualUser: '',

        showTaskManual: false,
        showTaskAuto: false,

        loadingAuto: false,
        loadingManual: false
    }

    componentDidMount() {
        //组件加载完成后触发
        //console.log('dataUserList',this.taskListRef?.state.dataUserList)
    }

    render() {
        const crumb = [
            {name: '智能研报'},
            {name: '任务分配'},
        ];
        const userColumns = [
            {title: "姓名", key: "user_name", dataIndex: "user_name",},
            {title: "登录名", key: "login_name", dataIndex: "login_name",},
            {
                title: "任务数", key: "user_id", dataIndex: "user_id",
                render: (text: string, row: any) => (
                    <Form.Item name={'TaskNumber_' + row.user_id} initialValue={0} style={{margin:0}}>
                    <InputNumber onChange={(e) => onTaskCountChanged(e, row.user_id)}
                                 min={0} precision={0}>
                    </InputNumber>
                    </Form.Item>
                )
            },
        ];
        const onTaskCountChanged = (v: number, user_id: number) => {
            const values = this.autoRef.current!.getFieldsValue();
            let sum = 0;
            for (const k in values) {
                sum += values[k];
            }
            this.setState({
                autoSum: sum
            });
        }
        return (
            <Layout>
                <NavHeader />
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>
                            <div id="toolBar">
                                <Space size={32}>
                                    <Button type="primary" onClick={this.openTaskAuto}>自动分配</Button>
                                    <Button type="primary" onClick={this.openTaskManual}>手动分配</Button>
                                </Space>
                            </div>

                            <TaskList ref={this.onTaskListRef} queryStatus={'0'} queryUser={''} ></TaskList>

                            <Modal title={'手动分配任务'}
                                   visible={this.state.showTaskManual}
                                   onOk={this.postTaskManual}
                                   onCancel={this.hideTaskModal}
                                   centered
                            >
                                <Spin tip="Loading..." size="large" spinning={this.state.loadingManual}>
                                    <div style={{padding: 36}} id="">
                                        您已选择
                                        <span className={'strong red'}>{this.taskListRef?.state.selectedTasks.length}</span>
                                        条任务，将所选择任务分配给：<br/>
                                        <div id='toolUsersSelect'>
                                            <Select style={{width: '380px', margin: '10px'}}
                                                    placeholder="请选择要分配的人员"
                                                    onChange={(val) => {
                                                        this.setState({manualUser: val})
                                                    }} >
                                                {DataUtil.selectOptionsRender(this.taskListRef?.state.dataUserList!, 'user_id', 'names')}
                                            </Select>
                                        </div>
                                    </div>
                                </Spin>
                            </Modal>

                            <Modal title={'自动分配任务'}
                                   visible={this.state.showTaskAuto}
                                   onOk={this.postTaskAuto}
                                   onCancel={this.hideTaskModal}
                                   forceRender={true}
                                   centered
                            >
                                <Spin tip="Loading..." size="large" spinning={this.state.loadingAuto}>
                                    <div style={{padding: 0}} id="">
                                        共 <span className={'strong red'}>{this.state.autoTotal}</span> 条未分配任务，
                                        将按以下设置分配
                                        <span className={'strong red'}>{this.state.autoSum}</span> 条任务：<br/>
                                        <Form ref={this.autoRef} autoComplete='off' component={false}>
                                        <Table key="taskUser"
                                               rowKey="id"
                                               size="small"
                                               columns={userColumns}
                                               dataSource={this.taskListRef?.state.dataUserList} pagination={false}
                                        />
                                        </Form>
                                    </div>
                                </Spin>
                            </Modal>
                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>
        );
    }

    // 开始自动分配任务
    openTaskAuto = () => {
        this.setState({showTaskAuto: true, loadingAuto: true});
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({
                    autoTotal: dat.total,
                    loadingAuto: false
                });
                this.taskListRef?.loadMainData();
            }
        }
        AxiosUtil.AxiosRequest('/api/ybTask/getTask', {taskStatus: 0, pageIndex: 1, pageSize: 0}, callback);
    }
    // 提交自动分配任务
    postTaskAuto = () => {
        if (this.state.autoSum > this.state.autoTotal) {
            message.error({content: '自动分配的任务总数不能大于未分配任务数！', className: 'message_error'});
            return;
        }
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                message.success({content: '任务分配完成！', className: 'message_success'});
                // 重置储存的数据
                this.setState({
                    showTaskAuto: false,
                    autoSum: 0
                });
                this.autoRef.current!.resetFields();
                this.taskListRef?.loadMainData();
            }
        }
        const values = this.autoRef.current!.getFieldsValue();
        let autoList = [];
        for (const k in values) {
            const uid = k.split('_')[1];
            autoList.push({
                userId: parseInt(uid),
                taskCount: values[k]
            });
        }
        AxiosUtil.AxiosRequest('/api/ybTask/setTask', {taskList: autoList}, callback);
    }

    //  手动分配任务
    openTaskManual = () => {
        // this.initAutoList();
        if (this.taskListRef?.state.selectedTasks.length === 0) {
            message.error({content: '请至少选择一条要分配的任务！', className: 'message_error'});
            return;
        }
        this.setState({showTaskManual: true});
    }
    postTaskManual = () => {
        if (!this.state.manualUser) {
            message.error({content: '请选择分配任务用户！', className: 'message_error'});
            return;
        }
        this.setState({loadingManual: true})
        let url = '/api/ybTask/setTaskByUser';
        let queryParam = {
            userId: this.state.manualUser,
            taskIdlList: this.taskListRef?.state.selectedTasks
        };
        const postCallback = (suc: boolean, dat: any) => {
            this.setState({loadingManual: false})
            if (suc) {
                message.success({content: '任务分配完成！', className: 'message_success'});
                this.setState({
                    selectedTasks: [],
                    showTaskManual: false,
                });
                this.taskListRef?.loadMainData();
            }
            this.setState({showLoading: false});
        }
        AxiosUtil.AxiosRequest(url, queryParam, postCallback);
    }

    hideTaskModal = () => {
        this.setState({
            showTaskManual: false,
            showTaskAuto: false,
        });
    }
}